module.exports = __webpack_public_path__ + "static/media/Marwan Abuabeid.e329bf7c.jpg";